export let CheckoutSrcOptions = /*#__PURE__*/function (CheckoutSrcOptions) {
  CheckoutSrcOptions["noImage"] = "noImage";
  CheckoutSrcOptions["surprise"] = "surprise";
  return CheckoutSrcOptions;
}({});
//# sourceMappingURL=checkoutImageTypes.js.map